import type { FaireProductEntity } from "../../entity_types/product";

export const p_49j8xgzkkw: FaireProductEntity = {
  token: "p_49j8xgzkkw",
  type: "product",
  name: "Women's Traditional Christmas Collar Pajama Set",
  brandToken: "b_br6ji29u",
  brandName: "Softies",
  imageUrl: "https://cdn.faire.com/fastly/a26fcb0994ff7818f46eb9daa625e1d642878c32db220aaba7942b34666e953b.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/7e92e7163e4565b50e4c765bcbdc3a1d6046b2b1c811fcf5a9fd315ccc767d39.jpeg",
    "https://cdn.faire.com/fastly/d58f39dfb7491c52062357e30d67f273d5d825fe3027788dab8163853e926562.png",
    "https://cdn.faire.com/fastly/46731b3ecf669159231948e3bbdaf1e13be1ec6555aac419a614c5c5d30544e4.png",
    "https://cdn.faire.com/fastly/25193427094afef5624f3132db5811447a8db74c20e4f7aa752d4d2686b6a5f1.png",
    "https://cdn.faire.com/fastly/4f0848ae18babe6ef6e22bbe977b20f600051584e765dcb279e070886a361ee3.png",
    "https://cdn.faire.com/fastly/dbf0279a016abab646701991e5d005384a2219b667f63294d87b160e0ab7c085.jpeg",
    "https://cdn.faire.com/fastly/93610249711acaa829ad16a2fb0eadabc708933fe5dee9db64ac8d6e9553ae01.png",
    "https://cdn.faire.com/fastly/38ae759bc2935124350888640c0b2189c6464f93b7a3e9ed1e7a48bc09183106.png",
    "https://cdn.faire.com/fastly/758f1dc87d3069429ed5fd78478891404a5f4f49ffbf42e6a18495b5f73161ec.png",
    "https://cdn.faire.com/fastly/a3162dcf0dbadd7c42a114bd76a763c329c10a7f6788f69819f4d0f96b6a1605.png"
  ],
  priceDollars: 65,
  description: "Elevate cozy nights with this luxurious pajama set, crafted from buttery-soft, breathable fabric with a cooling feel and just the right amount of stretch. The classic slim notch collar silhouette is perfect for restful nights, slow mornings, holiday gifting, and cozy seasonal lounging.\n\nFeatures:\n● Slim-fit notch collar top with classic button-front styling\n● Full-length pant with side pockets and adjustable drawstring waistband\n● Breathable, cooling fabric helps keep you comfortable throughout the night\n● 28\" inseam\n\nMaterials & Care:\n● 96% Modal, 4% Spandex\n● Machine wash cold with like colors\n● Tumble dry low; do not bleach\n● Colorfast, easy-care fabric\n\nBest For:\n● Restful nights and slow mornings\n● Lounging in luxurious comfort\n● Cozy weekends at home\n● Gifting for holidays, birthdays, and special occasions\n",
  tags: [],
  msrpDollars: 140,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-09-02T03:47:03.026Z",
    importedBy: "entity-db-cli"
  },
  categoryTokens: []
};
